import { PLATFORM } from '@lusha/source-platforms';
const findPlatformSubstring = (platform, substring) => {
    if (platform === null || platform === void 0 ? void 0 : platform.includes(substring)) {
        return platform;
    }
    return false;
};
export const mapPlatformFromParser = platform => {
    switch (platform) {
        case 'scout':
            return PLATFORM.EVERYWHERE;
        case findPlatformSubstring(platform, 'linkedin'):
            return PLATFORM.LINKEDIN;
        case findPlatformSubstring(platform, 'salesforce'):
            return PLATFORM.SALESFORCE;
        case findPlatformSubstring(platform, 'hubspot'):
            return PLATFORM.HUBSPOT;
        default:
            return PLATFORM.PLUGIN;
    }
};
